import { observer } from 'mobx-react-lite'
import { useActivation } from '@/hooks/view-model-hooks'
import { type PayoutReviewViewModel } from '@/features/payouts/admin/review/PayoutReviewViewModel'
import { PayoutReview } from '@/features/payouts/admin/review/components/PayoutReview'
import { PendingTransactionsTableContainer } from '@/features/payouts/admin/review/components/PendingTransactionsTable/PendingTransactionsTableContainer'
import { DraftingViewContainer } from '@/features/payouts/admin/review/components/DraftingView/DraftingViewContainer'
import { NewUserTransactionModalContainer } from '@/features/payouts/admin/review/components/NewUserTransactionModal/NewUserTransactionModalContainer'
import { CancelUserTransactionModalContainer } from '@/features/payouts/admin/review/components/CancelUserTransactionModal/CancelUserTransactionModalContainer'

export interface PayoutReviewContainerProps {
  vm: PayoutReviewViewModel
}

export const PayoutReviewContainer = observer(function PayoutReviewContainer({
  vm,
}: PayoutReviewContainerProps) {
  useActivation(vm)
  return (
    <PayoutReview
      canAccess={vm.canAccessPayoutsAdministration}
      sheetVisible={vm.draftingVm.approvedTransactions.length > 0}
      actionsDisabled={vm.actionsDisabled}
      onNewTransaction={vm.newUserTransactionVm.show}
      pendingTransactionsCount={vm.pendingTransactionsCount}
      pendingTransactionsTable={<PendingTransactionsTableContainer vm={vm} />}
      draftingView={<DraftingViewContainer vm={vm.draftingVm} />}
      dialogs={
        <>
          <NewUserTransactionModalContainer vm={vm.newUserTransactionVm} />
          <CancelUserTransactionModalContainer
            vm={vm.cancelUserTransactionVm}
          />
        </>
      }
    />
  )
})
